import { connect } from 'react-redux';
import { emit as _emit } from '../../actions/events';
import { changeView as _changeView } from '../../actions/view';
import { merge } from '../../actions/social';
import { SocialMergeView } from '../../components/SocialMergeView';

function mapStateToProps(state) {
  return {
    viewData: state.view.data,
    social: state.social
  };
}

function mapDispatchToProps(dispatch) {
  return {
    socialMerge: function socialMerge(parameters) {
      return dispatch(merge(parameters));
    },
    changeView: function changeView(view, data) {
      return dispatch(_changeView(view, data));
    },
    emit: function emit(type, event) {
      return dispatch(_emit(type, event));
    }
  };
}

export var SocialMergeViewContainer = connect(mapStateToProps, mapDispatchToProps)(SocialMergeView);